module.exports = __webpack_public_path__ + "img/Recubre_Yeso Lanzable.7dc3f21e.png";